<template>
  <div v-if="isLoadShow">
    <van-form @submit="submit" class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          readonly
          :value="value.positionCategoryName"
          label="期望职位"
          @click="jobList = true"
          is-link
          required
          placeholder="请选择期望职位"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          required
          :value="value.tradesName"
          label="期望行业"
          @click="industrySelect = true"
          is-link
          placeholder="请选择期望行业"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          required
          :value="value.areaName"
          label="工作区域"
          @click="wantedArea = true"
          is-link
          placeholder="请选择工作区域"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="showSelect('salaryExpect')"
          is-link
          required
          :value="value.salaryExpect"
          placeholder="请选择期望薪资"
          label="期望薪资"
          :rules="[{ required: true, message: '' }]"
        />

        <van-field
          input-align="right"
          readonly
          @click="showSelect('workType')"
          is-link
          required
          :value="value.workType"
          placeholder="请选择工作性质"
          label="工作性质"
          :rules="[{ required: true, message: '' }]"
        />

        <van-field
          v-if="isShow"
          readonly
          clickable
          label="求职状态"
          input-align="right"
          is-link
          required
          placeholder="请选择求职状态"
          :value="value.jobStatusName"
          @click="showSelect('jobStatusName')"
          :rules="[{ required: true, message: '' }]"
        />

        <slot></slot>

      </van-cell-group>
    </van-form>
    <!--选择职位-->
    <transition name="van-fade">
      <div class="job-pop" v-if="jobList">
        <!-- <div class="pop-header">
          <van-icon @click="jobList = false" name="fanhui"></van-icon>期望职位
        </div> -->
        <!--<h2 v-if="isShow">请选择您的期望职位</h2>-->
        <van-search
          readonly
          @click="focusSearch('selectJob', 'dictJobCategory')"
          placeholder="请输入关键词搜索您的职位类型"
        />
        <ul class="jobs">
          <li
            v-for="(item, index) of dictJobCategory"
            :key="item.index"
            :class="{ checked: jobChecked === index }"
            @click="checkedJobs(index, item)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </transition>
    <!--选择职位2-->
    <transition name="van-fade">
      <div class="job-pop job-pop2" v-if="jobList2">
        <!-- <div class="pop-header">
          <van-icon @click="jobSelect" name="fanhui"></van-icon>期望职位
        </div> -->
        <h2 v-if="isShow">请选择您的期望职位</h2>
        <van-search
          readonly
          @click="focusSearch('selectJob', 'dictJobCategory')"
          placeholder="请输入关键词搜索您的职位类型"
        />
        <div style="display: flex; height: 100%;">
          <div style="width: 60px;" @click="jobSelect"></div>
          <van-tree-select
            style="width: 100%;"
            :items="items"
            height="100%"
            :active-id.sync="value.positionCategoryId"
            :main-active-index.sync="activeIndex"
            @click-item="selectJob"
          />
        </div>
      </div>
    </transition>
    <!--选择期望行业-->
    <transition name="van-fade">
      <div
        class="job-pop"
        v-if="industrySelect"
        style="padding-bottom: 100px;"
      >
        <!-- <div class="pop-header">
          <van-icon @click="industrySelect = false" name="fanhui"></van-icon
          >期望行业
        </div> -->
        <h2 v-if="isShow">请选择您的期望行业</h2>
        <van-search
          readonly
          @click="focusSearch('selectTrade', 'dictTrades')"
          placeholder="请输入关键词搜索您的行业类型"
        />
        <van-tree-select
          :items="dictTrades"
          height="100%"
          :active-id.sync="value.tradesId"
          :main-active-index.sync="activeTradeIndex"
          @click-item="selectTrade"
        />
        <!-- <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <li v-for="item in selectedTrades" :key="item.index" @click="selectTrade(item, true)">{{item.text}}</li>
            </ul>
          </div>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" :disabled="activeTradeId.length > 3" round @click="onTrade">确定（{{ activeTradeId.length }}/3）</van-button>
        </div> -->
      </div>
    </transition>
    <!--期望工作区域-->
    <transition name="van-fade">
      <div class="job-pop" v-show="wantedArea" style="padding-bottom: 100px;">
        <!-- <div class="pop-header">
          <van-icon @click="wantedArea = false" name="fanhui"></van-icon
          >期望工作区域
        </div> -->
        <h2 v-if="isShow">请选择您的期望的工作区域</h2>
        <van-search
          readonly
          @click="focusSearch('selectArea', 'dictArea')"
          placeholder="请输入关键词搜索您的工作区域"
        />
        <van-tree-select
          :items="dictArea"
          height="100%"
          :active-id.sync="value.areaId"
          :main-active-index.sync="activeAreaIndex"
          @click-item="selectArea"
        />
        <!-- <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <li v-for="item in selectedAreas" :key="item.index" @click="selectArea(item, true)">{{item.text}}</li>
            </ul>
          </div>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" :disabled="activeAreaId.length > 3" round @click="onArea">确定（{{ activeAreaId.length }}/3）</van-button>
        </div> -->
      </div>
    </transition>

    <transition name="van-fade">
      <div class="job-pop" v-if="showSearch">
        <van-search
          show-action
          v-focus
          v-model="search"
          @search="onSearch"
          @cancel="onCancel"
          placeholder="请输入关键词搜索"
          ref="search">
          <template #action>
            <span @click="onSearch">搜索</span>
            <span @click="onCancel" style="padding-left: 10px;">取消</span>
          </template>
        </van-search>
        <div v-for="(item, key) in searchResult" :key="key" class="search-result" @click="searchSelect(item)">
          <p v-html="keyRegExp(item.childText, search)"></p>
          <!-- (item.third || item.second).replace(new RegExp(search, 'g'), '<span  class=str style=color:#2f72f6; >' + search + '</span>') -->
          <div>
            <span>{{ item.title || item.text }}</span>
            <span v-if="item.secondId"> - {{ item.second }}</span>
          </div>
        </div>
        <center>没有更多了</center>
      </div>
    </transition>

    <!--其他弹框-->
    <transition name="van-fade">
      <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </transition>

  </div>
  <div v-else style="
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;" >
    <van-loading size="40" />
  </div>
</template>

<script>
export default {
  name: "IntentionCommon",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.firstChild.firstChild.lastChild.firstChild.firstChild.focus()
        // el.focus();
      }
    }
  },
  data() {
    return {
      id: this.$route.query.id,
      value: {},
      isLoadShow:false,
      checked: false,
      jobList: false,
      jobList2: false,
      industrySelect: false,
      wantedArea: false,
      showPicker: false,
      jobChecked: '',
      items: [],
      activeId: 1,
      activeIndex: 0,
      activeTradeId: 1,
      activeTradeIndex: 0,
      activeAreaId: 1,
      activeAreaIndex: 0,
      dictJobCategory: [],
      dictTrades: [],
      dictArea: [],
      type: "",
      typeId: "",
      search: '',
      showSearch: false,
      searchResult: [],
      typeName: '',
      listName: ''
    };
  },
  computed: {
    columns() {
      const obj = {
        salaryExpect: Array.from(this.module.salaryMap.keys()),
        workType: Array.from(this.module.workType.keys()),
        jobStatusName: Array.from(this.module.jobStatus.keys())
      };
      return obj[this.type];
    }
  },
  watch: {
    jobList(val) {
      if(val) {
        this.dictJobCategory = this.module.getTree(this.dictJobCategory)
      }
    },
    industrySelect(val) {
      if(val) {
        this.dictTrades = this.module.getTree(this.dictTrades)
      }
    },
    wantedArea(val) {
      if(val) {
        this.dictArea = this.module.getTree(this.dictArea)
      }
    },
    items: {
      handler(val) {
        if (!val) return;
        val.filter((item, index) =>
          this.$set(this.items[index], "children", item.children)
        );
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.id && this.onload(this.id);
    this.getAPI('dictJobCategory')
    this.getAPI('dictTrades')
    this.getAreaAPI()
    setTimeout(()=>{
      this.isLoadShow = true
    },4000)
  },
  methods: {
    keyRegExp(str,key) {  // 搜索关键字高亮显示
      // 正则匹配中文、英文关键字高亮，高亮后的关键字和之前的大小写保持一致
      var key  = key;//这里定义关键词
      key = '('+key.replace(/([\+\.\*\|\?\-\(\[\^\$])/g,'\\$1' ).replace(/\s+/g,'|')+')';//把匹配关键字中的正则符转义
      var patt = new RegExp(key ,'igm'); //传  igm  可避免关键词后面的空格造成文字不匹配问题
      var str2 = str.replace(patt,"<span style='color: #5f99fc;'>$1</span>");
      return str2;
    },
    onload(id) {
      this.module.api.intentionDetail({
        params: { id },
        success: res => {
          for (let [key, value] of this.module.salaryMap.entries()) {
            value === res.salaryExpect && (res.salaryExpect = key);
          }
          for (let [key, value] of this.module.workType.entries()) {
            value === res.workType && (res.workType = key);
          }
          this.value = res;
        }
      });
    },
    getAPI(apiUrl) {
      const me = this;
      function fn(parentId=0) {
        me.module.api[apiUrl]({
          params: { parentId },
          success: (firstRes) => {
            firstRes.map(el => {
              if(el.hasChildren) {
                fn(el.id)
              }
            })
            me[apiUrl] = [...me[apiUrl], ...firstRes]
          }
        })
      }
      fn()
    },
    getAreaAPI(parentId=0, isBool=false) {
      this.module.api.dictArea({
        params: { parentId },
        success: (firstRes) => {
          firstRes.map(el => {
            if(el.hasChildren) {
              this.getAreaAPI(el.id, true)
            }
          })
          isBool && (this.dictArea = [...this.dictArea, ...firstRes])
        }
      })
    },
    checkedJobs(i, item) {
      this.items = item.children
      this.jobChecked !== i && (this.jobChecked = i);
      this.jobList2 = true;
    },
    selectJob({ id, text, childText, childId }) {
      Object.assign(this.value, {
        positionCategoryId: childId || id,
        positionCategoryName: childText || text
      });
      this[this.activeName] = childId
      this.jobList = false;
      this.jobList2 = false;
    },
    selectTrade({ id, text, childText, childId }, type) {
      Object.assign(this.value, { tradesId: childId || id, tradesName: childText || text });
      this.industrySelect = false;
      // type && this.activeTradeId.splice(this.activeTradeId.indexOf(val.id), 1)
      // let len = this.selectedTrades.filter((item, index) => item.id === val.id && this.selectedTrades.splice(index, 1)).length
      // !len && (this.selectedTrades = [...this.selectedTrades, val])
    },
    selectArea({ id, text, childText, childId }, type) {
      Object.assign(this.value, { areaId: childId || id, areaName: childText || text });
      this.wantedArea = false;
      // type && this.activeAreaId.splice(this.activeAreaId.indexOf(val.id), 1)
      // let len = this.selectedAreas.filter((item, index) => item.id === val.id && this.selectedAreas.splice(index, 1)).length
      // !len && (this.selectedAreas = [...this.selectedAreas, val])
    },
    showSelect(type, typeId) {
      this.type = type;
      typeId && (this.typeId = typeId);
      this.showPicker = true;
    },
    onConfirm(val) {
      this.value[this.type] = val;
      this.showPicker = false;
    },
    focusSearch(type, list) {
      this.showSearch = true
      this.typeName = type
      this.listName = list
    },
    onSearch(val) {
      this.searchResult = []
      const me = this
      let arr = JSON.parse(JSON.stringify(this[this.listName]))
      function getTips(arrs, list) {
        arrs.filter(item => {
          if(item.children) {
            getTips(item.children, item)
          } else {
            if(me.typeName.includes('selectJob')) {
              arr.filter(elem => {
                if(item.text.toUpperCase().includes(me.search.toUpperCase())){
                  me.searchResult.push({ ...elem, secondId: list.id, second: list.text, childId: item.id, childText: item.text })
                }
              })
            } else {
              if(item.text.toUpperCase().includes(me.search.toUpperCase())){
                me.searchResult.push({ ...list, childId: item.id, childText: item.text })
              }
            }
          }
        })
      }
      getTips(arr)
    },
    searchSelect(item) {
      this[this.typeName](item)
      this.onCancel()
    },
    onCancel() {
      this.search = ''
      this.searchResult = []
      this.showSearch = false
    },
    jobSelect() {
      this.jobList2 = false;
      this.jobList = true;
    },
    submit() {
      this.$emit('submit', this.value)
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  destroyed() {
    if (
      this.$route.name === "serviceTerms" ||
      this.$route.name === "statement"
    ) {
      this.module.user = this.value;
    }
  }
};
</script>

<style lang="less" scoped>
.user-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/.van-cell {
    display: flex;
    flex: 3;
    flex-direction: column;
    .van-field__label {
      margin-bottom: 26px;
    }
  }
  .user-img {
    position: relative;
    width: 88px;
    margin-right: 20px;
    flex: 2;
    text-align: right;
    img {
      width: 88px;
      height: 88px;
    }
    i {
      position: absolute;
      right: 0;
      top: 0;
      color: #2f72f6;
      font-size: 22px;
    }
  }
}
/deep/.van-hairline--top-bottom::after,
/deep/.van-hairline-unset--top-bottom::after {
  display: none;
}
/deep/.van-cell__right-icon {
  transform: rotate(90deg);
  top: -4px;
}

.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 1;
  }
}
.job-pop {
  position: fixed;
  padding-top: 54px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  top: 0;
  z-index: 999;
  overflow: auto;
  .fixed-bottom {
    z-index: 9999;
    flex-direction: column;
    button {
      width: 100%;
    }
    .selected {
      width: 100%;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      span {
        color: #b6b9bf;
        margin-right: 5px;
      }
      ul {
        display: flex;
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        li {
          background: #e4ebfb;
          border: 1px solid #4469e3;
          color: #4469e3;
          padding: 2px 24px 2px 10px;
          border-radius: 50px;
          margin: 0 3px;
          font-size: 12px;
          position: relative;
          &:after {
            content: "\e926";
            position: absolute;
            font-family: van-icon;
            top: 54%;
            right: 8px;
            transform: translate(0, -50%);
          }
        }
      }
    }
  }
  .pop-header {
    display: flex;
    justify-content: center;
    height: 50px;
    border-bottom: 1px solid #eee;
    align-items: center;
    color: #303132;
    position: relative;
    font-size: 16px;
    background: #fff;
    i {
      position: absolute;
      left: 20px;
      top: 50%;
      margin-top: -8px;
    }
  }
  h2 {
    padding: 22px 16px 0;
    color: #333;
    font-size: 22px;
    font-weight: bold;
    background: #fff;
  }
  .van-search {
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 10px;
    position: fixed;
    top:0;
    left:0;
    right:0;
    z-index: 999;
    .van-search__content {
      background: rgba(231, 236, 243, 0.3);
      border-radius: 50px;
      height: 40px;
      .van-cell {
        padding: 0 6px;
        line-height: 40px;
        /deep/input {
          padding-left: 6px;
          padding-top: 2px;
          &::placeholder {
            color: #c9ccd2;
          }
        }
        /deep/i {
          color: #e7ecf3;
        }
      }
    }
  }
  .jobs {
    display: flex;
    flex-direction: column;
    height: calc(100% - 54px);
    li {
      padding: 20px 0;
      margin: 0 20px;
      border-bottom: 1px solid #eee;
      position: relative;
      font-size: 16px;
      color: #5c5d5f;
      &.checked {
        color: #2f72f6;
      }
      &:after {
        content: "\e603";
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -7px;
        font-size: 16px;
        font-family: van-icon;
        color: #929292;
      }
    }
  }
  /deep/.van-tree-select{
    position: relative;
    height: calc(100% - 54px);
  }
  &.job-pop2 {
    background: rgba(0, 0, 0, 0.7);
  }
  .search-result {
    margin: 15px;
    color: #333;
    p {
      margin-bottom: 5px;
    }
    div {
      color: #b5b4b7;
    }
  }
}
/deep/.van-tree-select {
  .van-sidebar-item--select::before {
    background: #2f72f6;
  }
  .van-sidebar-item--select,
  .van-tree-select__item--active {
    color: #2f72f6;
  }
}
/deep/.van-sidebar-item__text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
